module.exports = __webpack_public_path__ + "../resources/images/illustration_sent-d7289b35210356798d511eca62ceba6d.svg";